import { Loader12 } from "./components/loader12";
import { Loader16 } from "./components/loader16";
import { Loader20 } from "./components/loader20";
import { Loader24 } from "./components/loader24";
import { Loader32 } from "./components/loader32";
import styles from "./loader.module.scss";
import type { LoaderFunction, LoaderProps } from "./types";

const sizeObject: Record<LoaderProps["size"], LoaderFunction> = {
	xl: (color: LoaderProps["color"]) => <Loader32 color={color} />,
	l: (color: LoaderProps["color"]) => <Loader24 color={color} />,
	m: (color: LoaderProps["color"]) => <Loader20 color={color} />,
	s: (color: LoaderProps["color"]) => <Loader16 color={color} />,
	xs: (color: LoaderProps["color"]) => <Loader12 color={color} />,
};

export const Loader = ({
	size = "xl",
	color = "accent",
	wrap = false,
}: LoaderProps) => {
	const loader = sizeObject[size](color);

	if (wrap) {
		return <div className={styles.container}>{loader}</div>;
	}

	return loader;
};
